function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".green{fill:#29ed87;}.black{fill:#2e293a;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-0.222 -0.444)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "green",
  cx: 21,
  cy: 21,
  r: 21,
  transform: "translate(0.222 0.444)"
}), /*#__PURE__*/React.createElement("path", {
  className: "black",
  d: "M2.37,4.741H0v2.37H2.37v7.111H5.926V7.111H8.083L8.3,4.741H5.926V3.753c0-.567.114-.791.661-.791H8.3V0H5.447C3.316,0,2.37.939,2.37,2.735Z",
  transform: "translate(16.889 14.222)"
}));
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.bef29dc86386879dfd2ab9be74d06af2.svg";
export { ForwardRef as ReactComponent };